import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  startDate: null,
  endDate: null,
  selectedSharedUid: null,
  selectedSite: null,
  siteOptions: [],
  page: 0,

  monitoringData: [],
  previousMonitoringData: [],
  systemMonitoringData: [],

  isDataAvailable: false,
  isPreviousDataAvailable: false,
  isSystemDataAvailable: false,

  loading: false,
  error: null,
};

const monitoringSlice = createSlice({
  name: "monitoring",
  initialState,
  reducers: {
    // UI-related states
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },

    // Data-related reducers
    fetchMonitoringStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchMonitoringSuccess: (state, action) => {
      state.loading = false;
      state.monitoringData = action.payload;
      state.isDataAvailable = true;
    },
    fetchMonitoringFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isDataAvailable = false;
    },

    fetchPreviousMonitoringSuccess: (state, action) => {
      state.previousMonitoringData = action.payload;
      state.isPreviousDataAvailable = true;
    },
    fetchPreviousMonitoringFailure: (state, action) => {
      state.error = action.payload;
      state.isPreviousDataAvailable = false;
    },

    fetchSystemMonitoringSuccess: (state, action) => {
      state.systemMonitoringData = action.payload;
      state.isSystemDataAvailable = true;
    },
    fetchSystemMonitoringFailure: (state, action) => {
      state.error = action.payload;
      state.isSystemDataAvailable = false;
    },
  },
});

export const {
  setStartDate,
  setEndDate,
  setSelectedSharedUid,
  setSelectedSite,
  setSiteOptions,
  setPage,

  fetchMonitoringStart,
  fetchMonitoringSuccess,
  fetchMonitoringFailure,

  fetchPreviousMonitoringSuccess,
  fetchPreviousMonitoringFailure,

  fetchSystemMonitoringSuccess,
  fetchSystemMonitoringFailure,
} = monitoringSlice.actions;

export default monitoringSlice.reducer;
